import React from 'react';
import API from '../../services/api.jsx'
import Helpers from '../../services/helpers.jsx'
import Loader from '../layout/loader.jsx'
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import Table from '../layout/table.jsx'
import { toast } from 'react-toastify'
import { debounce } from 'lodash'

class DeviceList extends React.Component {
	constructor(props) {
		super(props)

		const columns = [
			{
				label: 'Device name',
				key: 'name',
				canSort: true,
				onSortClick: column => this.onSort(column.key)
			}, 
			{
				label: 'SKU',
				key: 'sku',
				canSort: true,
				onSortClick: column => this.onSort(column.key)
			},
			{
				label: 'Type',
				key: 'type',
				canSort: true,
				view: function(field) {
					if(!field){
						return '-'
					}
					return (
						<div style={{whiteSpace: "nowrap"}}>{Helpers.DEVICES_TYPE_MAP[field] || '-'}</div>
					);
				},
				onSortClick: column => this.onSort(column.key)
			},
			{
				label: 'Status',
				key: 'lastPing',
				view: function(field) {
					if(!field)
						return <div className="red">offline</div>
					let timestamp = + new Date(field)
					let now = + new Date()
					return now - timestamp > 60 * 60 * 1000 ? <div className="red">offline</div> : <div className="green">online</div>
				}
			},
			{
				label: 'Storage left',
				key: 'storage',
				canSort: true,
				onSortClick: column => this.onSort(column.key),
				view: function(field){
					if(!field)
						return '-'
					return <div className={Helpers.lessThan1GB(field.externalAvailable) ? "red" : ""}>
						<div>
							{Helpers.formatBytes(field.externalAvailable)}
						</div>
						<div style={{whiteSpace: "nowrap"}}>
							{'/' + Helpers.formatBytes(field.externalTotal)}
						</div>
					</div>
				}
			},
			{
				label: 'Playing',
				key: 'playing'
			},
			{
				label: 'Timezone',
				key: 'timezone'
			},
			{
				label: 'Software version',
				key: 'softwareVersion',
				canSort: true,
				onSortClick: column => this.onSort(column.key)
			},
			{
				label: 'Download status',
				key: 'downloadStatus',
				view: function(field) {
					if(!field)
						return '-'
					else if(field.downloaded === field.total)
						return <div className="progress green"><i className="icon-done"></i> Downloaded</div>
					else
						return <div className="progress orange"><i className="icon-downloading"></i> {Math.round(field.downloaded/field.total*100)}% ({field.downloaded}/{field.total} tracks)</div>

				}
			}
		];
		if (Helpers.checkPermissions("devices:delete")){
			columns.push({
				action: 'delete',
				onClick: (id) => {
					var r = window.confirm("Are you sure you want to delete this device?");
					if (r === false) return

					this.setState({ loading: true })
					API.delete('devices', id).then(() => {
						toast.success('Device was successfully deleted')
						this.loadEntities()
					}).catch(() => {
						// toast.error('An unexpected error has occurred')
						this.setState({ loading: false })
					})
				}
			});
		}

		this.state = {
			loading: true,
			filters: {},
			postFilters: {},
			sort: ['createdAt', 'DESC'],
			devices: {
				columns,
				entities: [],
				filters: [
				{
					label: 'Status',
					placeholder: 'Status',
					type: 'select',
					value: null,
					isClearable: true,
					entities: [
						{name: 'Online', id: 'online'},
						{name: 'Offline', id: 'offline'}
					],
					onChange: value => {
						if(this.state?.postFilters?.['lastPing']?.value?.id !== value?.id){
							const filter = value ? this.buildPostFilter("lastPing", (val) => {
								let timestamp = + new Date(val);
								let now = + new Date();
								return now - timestamp > 60 * 60 * 1000 ? (value?.id === 'offline' ? true : false) : (value?.id === 'offline' ? false : true )
							}): null
							this.setState({
								devices: {
									...this.state.devices,
									filters: [
									{
										...this.state.devices.filters[0],
										value: value
									},
									this.state.devices.filters[1],	
									this.state.devices.filters[2],
									this.state.devices.filters[3],
									],
								},
								postFilters: {
									"lastPing": {
										value: value,
										filter: filter
									}
								}
							}, () => this.loadEntities())
						}
					}
				},
				{
					label: 'Search devices',
					onChange: debounce((value) => {
					if (value !== this.state.filters.name)
						this.setState(
						{
							filters: {
							...this.state.filters,
							name: value ? '/' + value + '/i' : '',
							},
						},
						() => {
							this.loadEntities();
						}
						);
					}, 500),
				},
				{
					label: 'Software version',
					placeholder: 'Software version',
					type: 'select',
					isClearable: true,
					entities: [],
					onChange: debounce(value => {
						if(value !== this.state.filters.softwareVersion)
							this.setState({ filters: { ...this.state.filters, softwareVersion: value ? '/' + value?.id + '/i' : '' }}, () => {
								this.loadEntities()
							})
					}, 500)
				}, {
					label: 'Search for a client',
					placeholder: 'Clients',
					isClearable: true,
					type: 'select',
					value: null,
					entities: [],
					onChange: value => {
						if(value !== this.state.filters.client)
							this.setState({ filters: { ...this.state.filters, client: value ? value.id : '' }, devices: { ...this.state.devices, filters: [this.state.devices.filters[0], this.state.devices.filters[1], this.state.devices.filters[2], { ...this.state.devices.filters[3], value: value }] }}, () => {
								this.loadEntities()
							})
					}
				}],
				actions: [],
				selectedItems: [],
				multiSelect: false,
				onRowClick: (entity) => {
					if (
						Helpers.checkPermissions(
							["devices:details", "devices:edit"],
							true
						)
					) {
						this.props.history.push('/devices/' + entity.id)
					}
				}
			}
		}
	}

	async componentDidMount() {
		let clientsRaw = await API.getAvaliableOptions("clients");
    	let clients = clientsRaw?.clients || [];
		clients = [...(clients || [])].sort(Helpers.caseInsensitiveAlphabeticalOrder);
		let clientIndex = clients.map(client => client.id)
		this.setState({ clients: clients, clientIndex: clientIndex, devices: {
			...this.state.devices,
			filters: [
				this.state.devices.filters[0],
				this.state.devices.filters[1],
				this.state.devices.filters[2],
				{
					...this.state.devices.filters[3],
					entities: clients,
				}
			]
		}}, () => {
			this.loadEntities()
		})
	}

	buildPostFilter = (key, filter) => {
		return (entity) => {
			if(entity?.[key]) return filter(entity?.[key]);
			else return false
		}
	}

	onSort(key){
		const newSort = this.state?.sort?.[0] === key ? 
		this.state?.sort?.[1] === "ASC" ? [key, 'DESC'] : [key, 'ASC'] 
		: [key, 'ASC'];
		this.setState({
			sort: newSort
		}, () => {
			this.loadEntities()
		})
	}

	loadEntities() {
		API.getDevices(this.state.filters, this.state.sort).then(entitiesRaw => {
			let entities = entitiesRaw?.data || [];
			let versions = new Set();
			entities?.forEach(entity => {
				if(entity?.softwareVersion){
					versions.add(entity?.softwareVersion)
				}
			})
			const versionsArr = Array.from(versions).sort().reverse();
			const versionsEntities = versionsArr?.map(version => ({name: version, id: version}));
			let postEntities = [...entities];
			if(this.state.postFilters && Object.entries(this.state.postFilters)?.length > 0){
				Object.keys(this.state?.postFilters)?.forEach(key => {
					if(typeof this.state.postFilters[key]?.filter === 'function'){
						postEntities = postEntities?.filter(this.state.postFilters[key].filter)
					}
				})
			}

			const filters = [
				{
					label: 'Status',
					placeholder: 'Status',
					type: 'select',
					isClearable: true,
					entities: [
						{ name: 'Online', id: 'online' },
						{ name: 'Offline', id: 'offline' }
					],
					onChange: value => {
						if(this.state?.postFilters?.['lastPing']?.value?.id !== value?.id){
							const filter = value ? this.buildPostFilter("lastPing", (val) => {
								let timestamp = + new Date(val);
								let now = + new Date();
								return now - timestamp > 60 * 60 * 1000 ? (value?.id === 'offline' ? true : false) : (value?.id === 'offline' ? false : true )
							}): null
							let newFilters = this.state.devices.filters;
							newFilters[1] = {
								...this.state.devices.filters[1],
								value: value
							}
							this.setState({
								devices: {
									...this.state.devices,
									filters: newFilters,
								},
								postFilters: {
									"lastPing": {
										value: value,
										filter: filter
									}
								}
							}, () => this.loadEntities())
						}
					}
				}
			];
			if (entitiesRaw?.filters?.availableFilters) {
				const filtersNames = ["name", "softwareVersion", "client"];
				entitiesRaw.filters.availableFilters = entitiesRaw.filters.availableFilters.filter((filter) => 
					filtersNames.includes(filter.name)
				);
				Helpers.handleFilters(this, filters, entitiesRaw);
			}
			this.setState({ ...this.state, loading: false, devices: {...this.state.devices, 
				filters,
				entities: postEntities} })
		})
	}

	render() {
		if(this.state.loading)
			return <Loader />
		else
			return <>
				<Head title={'Devices'} />
				<Content>
					<Table settings={this.state.devices} sort={this.state.sort} />
				</Content>
			</>
	}
}

export default DeviceList;
